define.alias("shared/components/shared/mavely/links/folder", "settings/components/shared/mavely/links/folder");